import React from 'react'
import {Skeleton} from 'antd'
import './skeleton-style.scss'

export default function AvatarSkeleton({ height,  maxWidth, block, size, avatarShape, width  }) {
    return (
        <>
            <div className={'heading-skeleton w-100'}
                 style={{  maxWidth: maxWidth, overflow:"hidden"}}
            >

                <Skeleton.Avatar
                    style={{
                        width:width,
                        height: height,
                    }}
                    active={true}  size={size ? '' : size} shape={avatarShape} />
            </div>
        </>
    )
}
